import { useEffect, useRef } from "react";

/** Ambient champagne light that follows the cursor across the entire viewport.
 * Uses lerp/rAF for buttery-smooth movement; pointer-events none. */
export default function MouseFollowLight() {
  const ref = useRef(null);
  const target = useRef({ x: 0, y: 0 });
  const pos = useRef({ x: 0, y: 0 });

  useEffect(() => {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) return;
    const el = ref.current;
    if (!el) return;

    target.current.x = window.innerWidth / 2;
    target.current.y = window.innerHeight / 2;
    pos.current = { ...target.current };

    let raf = 0;
    function tick() {
      pos.current.x += (target.current.x - pos.current.x) * 0.09;
      pos.current.y += (target.current.y - pos.current.y) * 0.09;
      el.style.transform = `translate3d(${pos.current.x - 320}px, ${pos.current.y - 320}px, 0)`;
      raf = requestAnimationFrame(tick);
    }
    function onMove(e) {
      target.current.x = e.clientX;
      target.current.y = e.clientY;
    }
    window.addEventListener("mousemove", onMove, { passive: true });
    raf = requestAnimationFrame(tick);
    return () => {
      window.removeEventListener("mousemove", onMove);
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      ref={ref}
      aria-hidden
      className="fixed top-0 left-0 pointer-events-none"
      style={{
        width: 640,
        height: 640,
        zIndex: 1,
        borderRadius: "50%",
        background: "radial-gradient(circle, rgba(198,168,124,0.18) 0%, rgba(198,168,124,0.06) 25%, transparent 60%)",
        filter: "blur(28px)",
        mixBlendMode: "screen",
        willChange: "transform",
      }}
    />
  );
}
